export const projects = [
  {
    id: 1,
    slug: 'nha-pho-bo-phi-binh-thanh',
    type: 'SỬA - BÁN',
    tag: 'Nhà Phố',
    title: 'Nhà Phố Xuống Cấp – Bình Thạnh',
    location: 'Bình Thạnh, TP.HCM',
    beforeImage: 'https://public.readdy.ai/ai/img_res/2d80b4022e56adc55a9c708e17f4d3ce.jpg',
    afterImage: 'https://readdy.ai/api/search-image?query=beautifully%20renovated%20Vietnamese%20townhouse%20minimalist%20white%20facade%20clean%20lines%20modern%20gate%20premium%20finish%20inner%20city%2C%20bright%20daylight%20real%20estate%20photography%20premium&width=800&height=600&seq=p1after&orientation=landscape',
    beforeValue: '9 tỷ',
    afterValue: '10.8 tỷ',
    investCost: '540 triệu',
    result: '+20% Giá Trị',
    roi: '333%',
    duration: '2 tháng',
    soldIn: '52 ngày',
    area: '90 m²',
    model: 'Tối ưu mặt tiền + nội thất staging Japandi để tăng giá bán',
  },
  {
    id: 2,
    slug: 'dat-trong-xay-chdv-go-vap',
    type: 'XÂY - THUÊ',
    tag: 'Nhà Nát',
    title: 'Nhà Nát 2 Tầng → CHDV 6 Tầng – Quận 3',
    location: 'Quận 3, TP.HCM',
    beforeImage: 'https://storage.readdy-site.link/project_files/8054470c-40ef-49ec-8cd3-eaeff47b62d7/638ebf07-f9c3-4c99-989b-d63e5092240c_f8f5e55ac83949671028.jpg?v=bbafd26bfe4706396acd9a5b8be11e97',
    afterImage: 'https://storage.readdy-site.link/project_files/8054470c-40ef-49ec-8cd3-eaeff47b62d7/81a8b16c-be98-475a-9070-881bc2c5c91c_b6af90efd83a6064392b.jpg?v=4e10803c2ef5f176c556e694fc0ac731',
    beforeValue: '12 triệu/tháng',
    afterValue: '77 triệu/tháng',
    investCost: '4.5 tỷ (xây)',
    result: '20.5% ROI/năm',
    roi: '20.5%/năm',
    duration: '9 tháng',
    rentedIn: '7 ngày',
    area: '80 m²',
    model: '8 căn studio full-furnished 6 tầng, vận hành cho thuê dài hạn bởi UPLIVING',
  },

  {
    id: 4,
    slug: 'nha-pho-kho-ban-tan-binh',
    type: 'SỬA - BÁN',
    tag: 'Nhà Phố',
    title: 'Nhà Phố Khó Bán 14 Tháng – Tân Bình',
    location: 'Tân Bình, TP.HCM',
    beforeImage: 'https://readdy.ai/api/search-image?query=dated%20Vietnamese%20shophouse%20townhouse%20interior%20dark%20cluttered%20old%20furniture%20for%20sale%20hard%20to%20sell%20before%20renovation%2C%20interior%20real%20estate%20photo%20dim%20lighting&width=800&height=600&seq=p4before&orientation=landscape',
    afterImage: 'https://readdy.ai/api/search-image?query=bright%20modern%20Vietnamese%20shophouse%20interior%20after%20renovation%20open%20concept%20living%20minimalist%20white%20walls%20light%20wood%20floors%20staging%20furniture%2C%20premium%20interior%20real%20estate%20photo&width=800&height=600&seq=p4after&orientation=landscape',
    beforeValue: '11 tỷ (14 tháng chưa bán)',
    afterValue: '13.9 tỷ',
    investCost: '880 triệu',
    result: '+26% & Bán 68 Ngày',
    roi: '330%',
    duration: '3 tháng',
    soldIn: '68 ngày',
    area: '130 m²',
    model: 'Staging + cải tạo toàn diện + chiến lược định vị lại phân khúc mua',
  },

  {
    id: 6,
    slug: 'villa-cu-ban-duoc-gia-thu-duc',
    type: 'SỬA - BÁN',
    tag: 'Nhà Phố',
    title: 'Nhà Phố 5 Tầng – Bán Thành Công Sau 4 Tháng',
    location: 'Nội Đô, TP.HCM',
    beforeImage: 'https://public.readdy.ai/ai/img_res/edited_c4c6ba9e207c6c46917f29d61cb1b65c_097578ca.jpg',
    afterImage: 'https://public.readdy.ai/ai/img_res/edited_7478fa21bb7ae373d8510c3d42c15cd8_ed5f5167.jpg',
    beforeValue: '33 tỷ',
    afterValue: '39.5 tỷ',
    investCost: '1.8 tỷ',
    result: '+20% Giá Trị',
    roi: '361%',
    duration: '75 ngày',
    soldIn: '2,5 + 1,5\u00a0tháng',
    area: '160 m²',
    model: 'Cải tạo toàn diện mặt tiền + nội thất + định vị lại phân khúc khách mua cao cấp',
  },
];
